import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Pages } from 'modules/navigation/domain/enums/pages';
import PlayerForm, { SubmitPlayerForm } from 'modules/players/ui/components/player-form';
import { TeamPlayer } from 'modules/teams/domain/interfaces/team-player';
import { useCreateTeamPlayer } from 'modules/teams/ui/hooks/use-create-team-player';

interface CreatePlayerProps {
  tournamentId: number;
  teamId: number;
  /** Весь состав команды — и заведённые вручную игроки, и вступившие участники. */
  players: TeamPlayer[];
  /** Переопределяет переход после успешного сохранения — нужно модалке, которая не хочет уходить со страницы. */
  onSuccess?: () => void;
  /** Переопределяет клик по «Отменить» в форме — см. `PlayerForm.onCancel`. */
  onCancel?: () => void;
}

const CreatePlayer = (props: CreatePlayerProps) => {
  const navigate = useNavigate();

  const { tournamentId, teamId, players, onSuccess, onCancel } = props;
  const playerId = Number(useLocation().state?.fromPlayer);

  const handleDisableForm = useCallback(() => {
    navigate(Pages.TEAMS.builders.edit(teamId, 'players'), {
      state: { fromPlayer: playerId },
    });
  }, [navigate, playerId, teamId]);

  const { createPlayer, isLoading } = useCreateTeamPlayer({
    tournamentId,
    teamId,
    players,
    onCreated: onSuccess ?? handleDisableForm,
  });

  const handleSubmit = useCallback<SubmitPlayerForm>(
    async ({ values, formikHelpers }) => {
      try {
        await createPlayer(values);
      } finally {
        formikHelpers.setSubmitting(false);
      }
    },
    [createPlayer],
  );

  return (
    <div className="pt-0">
      <PlayerForm onSubmit={handleSubmit} isLoading={isLoading} onCancel={onCancel} />
    </div>
  );
};

export default CreatePlayer;
